/* eslint-disable */
import 'intersection-observer'

if (__IS_LEGACY__) {
  require('core-js/shim')
  require('whatwg-fetch')
}
